import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsSeparator'
})
export class ThousandComaSeperatorPipe implements PipeTransform {

  transform(value: any, fraction: number=0): string {
    if (!value) return "0";
    if(fraction > 0){
      // console.log(value, 'value');
      
      value = parseFloat(value).toFixed(fraction);
      // console.log(value, 'value after');
    }
    let val, val1, val2, commaVal, finalVal;
    if(fraction > 0){
      val = value.split('.');
      val1 = val[0];
      val2 = val[1];
      commaVal = val1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "’");
      finalVal = commaVal+'.'+val2;
    }else{
      commaVal = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "’");
      finalVal = commaVal;
    }
    
    return finalVal;
}

}
